<template>
  <div class="financial-metrics">
    <FinanceIndicator class="section-margin" />
    <FinanceIncome :reportTypeMap="reportTypeMap" class="section-margin" />
    <FinanceBalance :reportTypeMap="reportTypeMap" class="section-margin" />
    <FinanceCash :reportTypeMap="reportTypeMap" />
  </div>
</template>

<script>
import FinanceIndicator from './finance/FinanceIndicator.vue'
import FinanceIncome from './finance/FinanceIncome.vue'
import FinanceBalance from './finance/FinanceBalance.vue'
import FinanceCash from './finance/FinanceCash.vue'

const REPORT_TYPE_MAP = {
  hk: {
    F: '年报',
    Q1: '一季报',
    I: '中报',
    Q3: '三季报'
  },
  us: {
    FY: '年报',
    Q1: '一季报',
    Q6: '二季报(累计)',
    Q9: '三季报(累计)'
  }
}

export default {
  components: {
    FinanceIndicator,
    FinanceIncome,
    FinanceBalance,
    FinanceCash
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    reportTypeMap() {
      return REPORT_TYPE_MAP[this.market]
    }
  }
}
</script>

<style lang="scss">
.finance-statements {
  background: var(--bg-color-2);
  &.key-indicator {
    .rk-switch--indicator {
      margin-bottom: 15px;
    }
    .position-wrap {
      position: relative;
    }
    .rk-select--indicator {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
